import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FloatingWrap, Switcher, Btn } from "./LanguageSwitcherStyles";

export default function LanguageSwitcher({ floating = false }) {
  const { i18n } = useTranslation();

  useEffect(() => {
    const saved = localStorage.getItem("i18nextLng");
    if (saved && saved !== i18n.language) {
      i18n.changeLanguage(saved);
    }

    document.documentElement.lang = i18n.language;

    const onLangChange = (lng) => {
      document.documentElement.lang = lng || "ro";
    };
    i18n.on("languageChanged", onLangChange);
    return () => i18n.off("languageChanged", onLangChange);
  }, [i18n]);

  const change = (next) => {
    i18n.changeLanguage(next);
    localStorage.setItem("i18nextLng", next);
    document.documentElement.lang = next;
  };

  const lng = i18n.resolvedLanguage || i18n.language || "ro";

  const content = (
    <Switcher aria-label="Language switcher">
      <Btn $active={lng === "ro"} onClick={() => change("ro")}>
        RO
      </Btn>
      <Btn $active={lng === "en"} onClick={() => change("en")}>
        EN
      </Btn>
    </Switcher>
  );

  if (floating) {
    return <FloatingWrap>{content}</FloatingWrap>;
  }

  return content;
}
